module.exports = __webpack_public_path__ + "static/media/CAAchessGif.c0ff4268.gif";